import { asyncActionCreator } from '../../global/redux';
import * as constants from './constants';

export const getFeedbacksByIdAction = asyncActionCreator(constants.GET_FEEDBACKS_BY_ID);
export const getStatsByIdAction = asyncActionCreator(constants.GET_STATS_BY_ID);
export const postFeedbackAction = asyncActionCreator(constants.POST_FEEDBACK);
